const DEFAULT_API_DOMAIN = 'https://api.dev.mymedhub.net';

function getApiDomain() {
    if (window.__MMH_CONFIG__ && window.__MMH_CONFIG__.apiUrl) {
        return window.__MMH_CONFIG__.apiUrl;
    }

    if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
        return '';
    }

    return DEFAULT_API_DOMAIN;
}

const Config = {
    apiDomain: getApiDomain(),
    version: '1.0',
    appName: 'MyMedHub',
};

export default Config;
